
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  name: 'App',
  components: {},
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.red {
  color: red;
}
.green {
  color: #34bc02;
}
.grey {
  color: #999;
}
.blue {
  color: #409eff;
}
.f12 {
  font-size: 12px;
}
li {
  list-style: none;
}
.p10 {
  padding: 10px;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.mr5 {
  margin-right: 5px;
}
.mr15 {
  margin-right: 15px;
}
.mr20 {
  margin-right: 20px;
}
.w200.el-input {
  width: 200px;
}
.cursor {
  cursor: pointer;
}
html,
body,
.h100 {
  height: 100%;
}
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.pr-device {
  padding: 5px 0 10px 20px;
  border-bottom: 1px solid #dcdcdc;
  .pr-device-title {
    display: inline-block;
    margin-right: 20px;
    font-size: 18px;
    color: #409eff;
  }
  .pr-code {
    display: inline-block;
    i {
      margin-right: 10px;
      font-size: 22px;
      color: #999;
    }
  }
  .pr-refresh {
    line-height: 28px;
  }
}
.pr-icon-bg {
  position: relative;
  float: left;
  width: 22px;
  height: 22px;
  margin-right: 5px;
  color: #fff;
  text-align: right;
  &::after {
    display: block;
    content: "";
    width: 0;
    height: 0;
    border-top: 10px solid red;
    border-right: 10px solid red;
    border-bottom: 10px solid transparent;
    border-left: 10px solid transparent;
  }
  i {
    position: absolute;
    top: -2px;
    left: 7px;
  }
  .f12 {
    font-size: 12px;
  }
}
.pr-icon-bg.blue {
  &::after {
    border-top: 10px solid #409eff;
    border-right: 10px solid #409eff;
  }
}
.pr-icon-bg.orange {
  &::after {
    border-top: 10px solid orange;
    border-right: 10px solid orange;
  }
}
.pr-circular {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: middle;
  border-radius: 15px;
  &::after {
    display: block;
    content: "";
    width: 7px;
    height: 7px;
    margin: 4px 0 0 4px;
    border-radius: 7px;
  }
}
.pr-circular-green {
  background: rgba(52, 188, 2, 0.3);
  &::after {
    background: rgba(52, 188, 2, 1);
  }
}
.pr-circular-red {
  background: rgba(255, 0, 0, 0.3);
  &::after {
    background: rgba(255, 0, 0, 1);
  }
}
.pr-circular-grey {
  background: rgba(0, 0, 0, 0.3);
  &::after {
    background: rgba(0, 0, 0, 0.3);
  }
}
.pr-card-list {
  padding: 20px 0 20px 8px;
  margin-right: -15px;
  overflow: hidden;
  dt {
    margin-bottom: 5px;
    font-size: 14px;
  }
  dd {
    position: relative;
    width: 210px;
    height: 110px;
    margin-right: 15px;
    margin-bottom: 15px;
    float: left;
    overflow: hidden;
    border-radius: 4px;
    text-align: center;
    background: #e7edf9;
    border: 1px solid #dcdcdc;
  }
  h3 {
    margin: 10px 0;
    font-size: 16px;
    font-weight: normal;
  }
  p {
    margin-top: 10px;
    color: #666;
    i {
      margin-left: 10px;
      font-size: 20px;
      color: #999;
      cursor: pointer;
    }
  }
  .pr-icon-bg {
    position: absolute;
    top: 0;
    right: 3px;
    &::after {
      border-top: 15px solid red;
      border-right: 15px solid red;
      border-bottom: 15px solid transparent;
      border-left: 15px solid transparent;
    }
    i {
      top: 1px;
      left: 13px;
    }
  }
  .pr-icon-bg.blue {
    &::after {
      border-top: 15px solid #409eff;
      border-right: 15px solid #409eff;
    }
  }
  .pr-icon-bg.orange {
    &::after {
      border-top: 15px solid orange;
      border-right: 15px solid orange;
    }
  }
}

.el-dialog__header {
  border-bottom: 1px solid #dcdcdc;
}
.el-table td,
.el-table th {
  padding: 5px 0 !important;
}
.el-pagination {
  margin: 20px auto;
  text-align: right;
}
</style>
